import styled from 'styled-components';
const CollapsableSidebarContainer = styled.div.withConfig({
  displayName: "CollapsableSidebarContainer",
  componentId: "h1bf5e-0"
})(["position:relative;height:100%;flex-basis:", "px;transition:all 200ms cubic-bezier(0.42,0,0.58,1);"], props => props.width);
export default CollapsableSidebarContainer;